
import { CountryData, WIRPhaseTypes } from 'types/wellGuardian';

import {
  Phase,
  WIRCreateJourneyStepsKeys,
  WIREngineeringWorkSections,
  WIRFinalPreparationSections,
  WIRFinalWIRSections,
  WIRInterventionCloseOutSections,
  WIRInterventionOperationSections,
  WIRKofMeetingTechnicalWirSections,
  WIRPhaseSectionApiKeys,
  WIRReactiveScopeSections,
  WIRSectionKeys,
  WIRSections,
  WIRStageGate1Sections,
  WIRStageGate2Sections,
  WIRStageGate3Sections,
  WIRStageGate4Sections,
  WIRStageGate5Sections,
} from '../wir.constants';

export function getSectionApiKey(sectionKey: string, wirSection: WIRSectionKeys) {
  return wirSection[sectionKey as keyof typeof wirSection];
}

export function getSectionKey(
  section: string,
  wirSections: WIRSections | typeof WIRPhaseSectionApiKeys,
) {
  for (const sectionKey in wirSections) {
    if (section === wirSections[sectionKey as keyof typeof wirSections]) {
      return sectionKey;
    }
  }

  return '';
}

export function getCountrySections(phase: string) {
  switch (phase) {
    case WIRCreateJourneyStepsKeys.REACTIVE_SCOPE:
      return WIRReactiveScopeSections;
    case WIRCreateJourneyStepsKeys.KICK_OFF_TECHNICAL_WIR:
    case WIRCreateJourneyStepsKeys.CG_KICK_OFF_TECHNICAL_WIR:
      return WIRKofMeetingTechnicalWirSections;
    case WIRCreateJourneyStepsKeys.ENGINEERING_WORK:
    case WIRCreateJourneyStepsKeys.CG_ENGINEERING_WORK:
    case WIRCreateJourneyStepsKeys.AG_ENGINEERING_WORK:
    case WIRCreateJourneyStepsKeys.IRAQ_ENGINEERING_WORK:
    case WIRCreateJourneyStepsKeys.ARGENTINA_ENGINEERING_WORK:
      return WIREngineeringWorkSections;
    case WIRCreateJourneyStepsKeys.FINAL_WIR:
    case WIRCreateJourneyStepsKeys.CG_FINAL_WIR:
    case WIRCreateJourneyStepsKeys.AG_FINAL_WIR:
    case WIRCreateJourneyStepsKeys.IRAQ_FINAL_WIR:
    case WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_WIR:
      return WIRFinalWIRSections;
    case WIRCreateJourneyStepsKeys.FINAL_PREPARATION:
    case WIRCreateJourneyStepsKeys.NG_FINAL_PREPARATION:
    case WIRCreateJourneyStepsKeys.CG_FINAL_PREPARATION:
    case WIRCreateJourneyStepsKeys.AG_FINAL_PREPARATION:
    case WIRCreateJourneyStepsKeys.IRAQ_FINAL_PREPARATION:
    case WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_PREPARATION:
      return WIRFinalPreparationSections;
    case WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION:
    case WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION:
    case WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION:
    case WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION:
    case WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION:
    case WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION:
      return WIRInterventionOperationSections;
    case WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT:
    case WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT:
    case WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT:
    case WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT:
    case WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT:
    case WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT:
      return WIRInterventionCloseOutSections;
    case WIRCreateJourneyStepsKeys.STAGE_GATE_1:
      return WIRStageGate1Sections;
    case WIRCreateJourneyStepsKeys.STAGE_GATE_2:
      return WIRStageGate2Sections;
    case WIRCreateJourneyStepsKeys.STAGE_GATE_3:
      return WIRStageGate3Sections;
    case WIRCreateJourneyStepsKeys.STAGE_GATE_4:
      return WIRStageGate4Sections;
    case WIRCreateJourneyStepsKeys.STAGE_GATE_5:
      return WIRStageGate5Sections;
    default:
      return WIREngineeringWorkSections;
  }
}

export function getPhaseName(phase: string) {
  for (const key in WIRCreateJourneyStepsKeys) {
    if (phase === WIRCreateJourneyStepsKeys[key as keyof typeof WIRCreateJourneyStepsKeys]) {
      return key;
    }
  }

  return '';
}

export const getWirCreatedSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_2;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_WIR_CREATED;
    default:
      return WIRCreateJourneyStepsKeys.WIR_CREATED;
  }
};

export const getWirCreatedPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_2;
    case CountryData.congo:
      return WIRPhaseTypes.CG_WIR_CREATED;
    default:
      return WIRPhaseTypes.WIR_CREATED;
  }
};

export const getWirCreatedStageGate1SectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_1;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_WIR_CREATED;
    default:
      return WIRCreateJourneyStepsKeys.WIR_CREATED;
  }
};

export const getKickOffSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_2;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_KICK_OFF_TECHNICAL_WIR;
    default:
      return WIRCreateJourneyStepsKeys.KICK_OFF_TECHNICAL_WIR;
  }
};

export const getKickOffPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_2;
    case CountryData.congo:
      return WIRPhaseTypes.CG_KICK_OFF_TECHNICAL_WIR;
    default:
      return WIRPhaseTypes.KICK_OFF_TECHNICAL_WIR;
  }
};

export const getEngineeringWorkSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_3;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_ENGINEERING_WORK;
    case CountryData.angola:
      return WIRCreateJourneyStepsKeys.AG_ENGINEERING_WORK;
    case CountryData.iraq:
      return WIRCreateJourneyStepsKeys.IRAQ_ENGINEERING_WORK;
    case CountryData.argentina:
      return WIRCreateJourneyStepsKeys.ARGENTINA_ENGINEERING_WORK;
    default:
      return WIRCreateJourneyStepsKeys.ENGINEERING_WORK;
  }
};

export const getEngineeringWorkPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_3;
    case CountryData.congo:
      return WIRPhaseTypes.CG_ENGINEERING_WORK;
    case CountryData.angola:
      return WIRPhaseTypes.AG_ENGINEERING_WORK;
    case CountryData.iraq:
      return WIRPhaseTypes.IRAQ_ENGINEERING_WORK;
    case CountryData.argentina:
      return WIRPhaseTypes.ARGENTINA_ENGINEERING_WORK;
    default:
      return WIRPhaseTypes.ENGINEERING_WORK;
  }
};

export const getFinalWirSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_3;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_FINAL_WIR;
    case CountryData.angola:
      return WIRCreateJourneyStepsKeys.AG_FINAL_WIR;
    case CountryData.iraq:
      return WIRCreateJourneyStepsKeys.IRAQ_FINAL_WIR;
    case CountryData.argentina:
      return WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_WIR;
    default:
      return WIRCreateJourneyStepsKeys.FINAL_WIR;
  }
};

export const getFinalWirPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_3;
    case CountryData.congo:
      return WIRPhaseTypes.CG_FINAL_WIR;
    case CountryData.angola:
      return WIRPhaseTypes.AG_FINAL_WIR;
    case CountryData.iraq:
      return WIRPhaseTypes.IRAQ_FINAL_WIR;
    case CountryData.argentina:
      return WIRPhaseTypes.ARGENTINA_FINAL_WIR;
    default:
      return WIRPhaseTypes.FINAL_WIR;
  }
};

export const getFinalPreparationSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.nigeria:
      return WIRCreateJourneyStepsKeys.NG_FINAL_PREPARATION;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_FINAL_PREPARATION;
    case CountryData.angola:
      return WIRCreateJourneyStepsKeys.AG_FINAL_PREPARATION;
    case CountryData.iraq:
      return WIRCreateJourneyStepsKeys.IRAQ_FINAL_PREPARATION;
    case CountryData.argentina:
      return WIRCreateJourneyStepsKeys.ARGENTINA_FINAL_PREPARATION;
    default:
      return WIRCreateJourneyStepsKeys.FINAL_PREPARATION;
  }
};

export const getFinalPreparationPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.nigeria:
      return WIRPhaseTypes.NG_FINAL_PREPARATION;
    case CountryData.congo:
      return WIRPhaseTypes.CG_FINAL_PREPARATION;
    case CountryData.angola:
      return WIRPhaseTypes.AG_FINAL_PREPARATION;
    case CountryData.iraq:
      return WIRPhaseTypes.IRAQ_FINAL_PREPARATION;
    case CountryData.argentina:
      return WIRPhaseTypes.ARGENTINA_FINAL_PREPARATION;
    default:
      return WIRPhaseTypes.FINAL_PREPARATION;
  }
};

export const getInterventionOperationSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_4;
    case CountryData.nigeria:
      return WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION;
    case CountryData.angola:
      return WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION;
    case CountryData.iraq:
      return WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION;
    case CountryData.argentina:
      return WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION;
    default:
      return WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION;
  }
};

export const getInterventionOperationPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_4;
    case CountryData.nigeria:
      return WIRPhaseTypes.NG_INTERVENTION_OPERATION;
    case CountryData.congo:
      return WIRPhaseTypes.CG_INTERVENTION_OPERATION;
    case CountryData.angola:
      return WIRPhaseTypes.AG_INTERVENTION_OPERATION;
    case CountryData.iraq:
      return WIRPhaseTypes.IRAQ_INTERVENTION_OPERATION;
    case CountryData.argentina:
      return WIRPhaseTypes.ARGENTINA_INTERVENTION_OPERATION;
    default:
      return WIRPhaseTypes.INTERVENTION_OPERATION;
  }
};

export const getInterventionOperationWellHandOver = (country: string) => {
  switch (country) {
    case CountryData.unitedKingdom:
      return [
        'wellHandoverIntervStart',
        'wellHandoverBackToOpsEnd'
      ];
    default:
      return [
        'wellHandoverIntervStart',
        'wellHandoverBackToOpsEnd'
      ];
  }
};

export const getInterventionCloseOutSectionKey = (country: string): Phase => {
  switch (country) {
    case CountryData.denmark:
      return WIRCreateJourneyStepsKeys.STAGE_GATE_5;
    case CountryData.nigeria:
      return WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT;
    case CountryData.congo:
      return WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT;
    case CountryData.angola:
      return WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT;
    case CountryData.iraq:
      return WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT;
    case CountryData.argentina:
      return WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT;
    default:
      return WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT;
  }
};

export const getInterventionCloseOutPhaseName = (country: string): WIRPhaseTypes => {
  switch (country) {
    case CountryData.denmark:
      return WIRPhaseTypes.STAGE_GATE_5;
    case CountryData.nigeria:
      return WIRPhaseTypes.NG_INTERVENTION_CLOSE_OUT;
    case CountryData.congo:
      return WIRPhaseTypes.CG_INTERVENTION_CLOSE_OUT;
    case CountryData.angola:
      return WIRPhaseTypes.AG_INTERVENTION_CLOSE_OUT;
    case CountryData.iraq:
      return WIRPhaseTypes.IRAQ_INTERVENTION_CLOSE_OUT;
    case CountryData.argentina:
      return WIRPhaseTypes.ARGENTINA_INTERVENTION_CLOSE_OUT;
    default:
      return WIRPhaseTypes.INTERVENTION_CLOSE_OUT;
  }
};

export const getInterventionCloseoutChecklists = (country: string) => {
  switch (country) {
    case CountryData.denmark:
      return [
        'interventionSingleSlideSummary',
        'completionSchematicUpdate',
        'wellSchematicUpdate',
        'interventionWellDataStored',
        'vendorCloseOut',
        'assetCloseOutPresentation',
        'rex',
        'costConsolidationCloseOut',
      ];
    case CountryData.nigeria:
      return [
        'interventionSingleSlideSummary',
        'completionSchematicUpdate',
        'wellSchematicUpdate',
        'interventionWellDataStored',
        'vendorCloseOut',
        'rex',
        'costConsolidationCloseOut',
      ];
    case CountryData.iraq:
    case CountryData.argentina:
      return [
        'interventionSingleSlideSummary',
        'completionSchematicUpdate',
        'wellSchematicUpdate',
        'interventionWellDataStored',
        'vendorCloseOut',
        'rex',
        'costConsolidationCloseOut',
        'uwimsUpdated',
      ];
    case CountryData.congo:
      return [
        'interventionSingleSlideSummary',
        'lessonsCaptured',
        'completionSchematicUpdate',
        'wellSchematicUpdate',
        'interventionWellDataStored',
        'vendorCloseOut',
        'assetCloseOutPresentation',
        'rex',
        'costConsolidationCloseOut',
      ];
    default:
      return [
        'interventionSingleSlideSummary',
        'capPortalCloseOut',
        'signOffWcrs',
        'completionSchematicUpdate',
        'wellSchematicUpdate',
        'rex',
        'emtraxUpdate',
        'vendorCloseOut',
        'interventionWellDataStored',
        'assetCloseOutPresentation',
        'costConsolidationCloseOut',
      ];
  }
};

export const getIsPiLinkVisible = (country: string) => {
  switch (country) {
    case CountryData.unitedKingdom:
    case CountryData.nigeria:
    case CountryData.iraq:
    case CountryData.angola:
    case CountryData.brazil:
    case CountryData.congo:
    case CountryData.argentina:
      return true;
    default:
      return false;
  }
};
